<template>
  <el-card class="detail-card eval-card" shadow="never">
    <div slot="header" class="card-header">
      <span class="card-title"><i class="el-icon-s-data"></i> 项目评估</span>
      <el-tag type="info" size="mini">开发中</el-tag>
    </div>
    <div class="eval-placeholder">
      <i class="el-icon-s-order"></i>
      <!-- <p>项目评估功能后一阶段再做，先暂放</p> -->
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'ProjectEvalCard'
}
</script>

<style lang="scss" scoped>
/* 卡片统一样式 */
.detail-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  ::v-deep .el-card__header {
    padding: 14px 20px;
    border-bottom: 1px solid #ebeef5;
    background: #fafbfc;
  }
  ::v-deep .el-card__body {
    padding: 20px;
  }
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  i {
    margin-right: 6px;
    color: #409eff;
  }
}

/* 评估占位 */
.eval-card {
  ::v-deep .el-card__body {
    padding: 40px 20px;
  }
}
.eval-placeholder {
  text-align: center;
  color: #c0c4cc;
  i {
    font-size: 48px;
    margin-bottom: 12px;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
}
</style>